import { Controller } from '@hotwired/stimulus';
import { setPanelOpen } from '../lib/disclosure_panel';

export default class extends Controller {
  get panel() {
    return document.getElementById(this.element.getAttribute('aria-controls'));
  }

  toggle() {
    const panel = this.panel;
    if (!panel) return;

    const open = this.element.getAttribute('aria-expanded') !== 'true';
    if (open) this.dispatch('open', { detail: { panel } });

    setPanelOpen(panel, open);
  }
}
